<template>
  <div class="file">
    <div class="file-list">
      <div class="head flex flex-row flex-between">
        <div class="head-title">标准查询</div>
        <div class="search flex flex-middle">
          <div class="search-tag">查标准</div>
          <SearchBarCircle
            :num="totalItem"
            v-model="fileTitle"
            @btnClick="getList"
            placeholder="请输入关键字"
          />
        </div>
        <!-- <div class="search flex">
          <el-button class="head-btn" plain type="primary" @click="batchClick">
            标准批量查新
          </el-button> -->
        <!-- <el-button class="head-btn" plain @click="resetClick">
            重置
          </el-button>
        </div> -->
      </div>
    </div>
    <div class="file-tableWrap">
      <Table :data="list" :columns="columns" stripe>
        <template slot-scope="scope" slot="standardFileTitle">
          <div
            @click="fileDetailsClick(scope.row.standardFileId)"
            class="file-name pointer"
          >
            {{ scope.row.standardFileTitle }}
          </div>
        </template>
      </Table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        align="right"
        layout="total,sizes,prev, pager, next,jumper"
        :total="totalItem"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.pageIndex"
        @size-change="queryByCretira"
        @current-change="getList"
      />
    </div>

    <BatchSearchDialog v-model="showBatch" @uploadSuccess="uploadSuccess" />
  </div>
</template>

<script>
import { standardFileList } from "@/api/standardFile";
import Table from "@/components/Table/index";
import { mapGetters } from "vuex";
import BatchSearchDialog from "./batchSearchDialog";
import SearchBarCircle from "@/components/SearchBarCircle/index";
export default {
  components: {
    Table,
    BatchSearchDialog,
    SearchBarCircle,
  },
  data() {
    return {
      page: { pageIndex: 1, pageSize: 20 },
      fileTitle: "",
      list: [],
      totalItem: 0,
      columns: [
        { slotName: "standardFileTitle", label: "标准查询" },
        { prop: "standardFileCode", label: "标准号", width: 180 },
        // { prop: "standardFileVisits", label: "浏览次数", width: 80 },
        // { prop: "standardFileDownloads", label: "下载次数", width: 80 },
        { prop: "createTime", label: "上传时间", width: 170 },
      ],
      showBatch: false,
      standardFileList: [],
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const params = {
        ...this.page,
        standardFileTitle: this.fileTitle,
        standardFileList: this.standardFileList,
      };
      const { list, totalItem } = await this.$axios.post(
        standardFileList,
        params
      );
      this.list = list;
      this.totalItem = totalItem;
    },
    queryByCretira() {
      this.page.pageIndex = 1;
      this.getList();
    },
    async fileDetailsClick(id) {
      if (this.token) {
        const { href } = this.$router.resolve({
          path: "/standardFileDetail",
          query: {
            id,
          },
        });
        window.open(href);
      } else {
        this.$store.dispatch("login");
      }
    },

    // 标准批量查新
    batchClick() {
      this.showBatch = true;
    },

    uploadSuccess(data) {
      this.standardFileList = data;
      this.getList();
    },
    resetClick() {
      this.standardFileList = [];
      this.page.pageIndex = 1;
      this.fileTitle = "";
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variable";

.head {
  &-title {
    padding-top: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  &-btn {
    margin-left: 10px;
  }
}
::v-deep .el-table {
  th.is-leaf {
    border-bottom: none;
  }
  td {
    border-bottom: none;
  }
  &__row--striped {
    .file {
      &-name {
        color: $theme-color;
      }
    }
  }
}
.file {
  padding: 16px 24px;
  background: white;
  &-name {
    text-align: left;
  }
  &-tableWrap {
    margin-top: 16px;
    min-height: 850px;
    border-top: 1px solid #e6e6e6;
  }
}
.pagination {
  margin-top: 40px;
}
.search {
  ::v-deep &-input {
    width: 300px;
  }
  &-tag {
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
    background: #ff9531;
    color: #fff;
    border-radius: 16px 0 16px 0;
    margin-right: 10px;
  }
}
</style>
